export const PAGINATION_OPTIONS = [ 50, 100, 200, 400, 500];
export const TABLE_HEIGHT = 600;
export const TABLE_SORT_ORDER = "asc";
